// 栏目列表
class ColumnListData {
	constructor(guid = '', type = '', title = '', groupType = 'in', titleLength = 0, descLength = 0, ext = '...', count = '0', tagIds = '') {
		this.guid = guid;
		this.type = type;
		this.title = title;

		this.groupType = groupType || 'in';
		this.titleLength = titleLength || 0;
		this.descLength = descLength || 0;
		this.ext = ext || '...';
		this.count = count || '0';

		this.tagIds = tagIds;
	}
}

export default ColumnListData;



// WEBPACK FOOTER //
// ./src/script/baseData/columnList/columnListData.js